module.exports = __webpack_public_path__ + "static/media/SuccessCheckBox.49f6c4d1.svg";